import React, { useEffect, useRef, useState } from 'react';
import styled, { css } from 'styled-components';

import { IconButton } from 'components/molecules/Button';
import DropDown from 'components/organisms/DropDown/DropDown';
import useClickOutside from 'services/hooks/useClickOutside';

const TaskOptionDropDownContainer = styled.div`
    position: relative;
`;

const activeIconStyles = css`
    box-shadow: 2px 0 6px rgba(0, 0, 0, 0.1), 2px 0 2px rgba(0, 0, 0, 0.03);

    & circle {
        fill: #212121;
    }
`;

const StyledIconButton = styled(IconButton)`
    width: 24px;
    height: 24px;
    background-color: white;
    border-radius: 6px;
    transform: rotate(90deg);

    ${(props) => props.isMenuOpen && activeIconStyles}

    &:hover {
        ${activeIconStyles}
    }

    & > svg {
        width: 4px;
        height: 16px;
    }
`;

const StyledDropDown = styled(DropDown)`
    min-width: 110px;
    width: fit-content;
    right: 0;
    border-radius: 12px;
    cursor: default;
    margin-top: 8px;

    ${(props) =>
        props.direction === 'down'
            ? css`
                  top: 90%;
              `
            : css`
                  bottom: 25px;
              `}
`;

const defaultItemList = [
    { value: 'edit', title: 'Edit' },
    { value: 'delete', title: 'Delete' },
    { value: 'duplicate', title: 'Duplicate' },
];

const TaskOptionDropDown = ({ className, direction = 'down', itemList = defaultItemList, onSelect, onOpenChange }) => {
    const dropDownRef = useRef(null);
    const [isOpen, setIsOpen] = useState(false);

    const handleClick = (e) => {
        e.stopPropagation();
        setIsOpen((isOpen) => !isOpen);
    };

    const handleItemClick = (e, data) => {
        onSelect(data);
        setIsOpen(false);
    };

    useClickOutside(dropDownRef, () => {
        setIsOpen(false);
    });

    useEffect(() => {
        if (isOpen) dropDownRef.current.focus();
        onOpenChange && onOpenChange(isOpen);
    }, [isOpen]);

    return (
        <TaskOptionDropDownContainer className={className}>
            <StyledIconButton kind={'dot'} iconColor={'black'} isMenuOpen={isOpen} onClick={handleClick} />
            <StyledDropDown
                ref={dropDownRef}
                open={isOpen}
                direction={direction}
                handler={'onClick'}
                shouldPreventDefault={true}
                shouldStopPropagation={true}
                itemList={itemList}
                handleSelected={handleItemClick}
            />
        </TaskOptionDropDownContainer>
    );
};

export default TaskOptionDropDown;
